import styles from './LandingLayout.module.css';

const RefundPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>Legal</div>
      <h2 className={styles.sectionTitle}>Refund &amp; Cancellation Policy</h2>
      <div className={styles.legalBody}>
        <p><strong>Effective Date:</strong> 1 January 2026</p>
        <p><strong>Last Updated:</strong> June 2026</p>
        <p>
          This Policy governs all financial transactions processed through the JainamSevaSetu platform
          ("Platform"), operated by the <strong>JainamSevaSetu</strong> team.
        </p>

        <h3>1. Donations — JainamSevaSetu's Role</h3>
        <p>
          JainamSevaSetu is a <strong>software management platform only</strong>. When a Derasar enables online
          payments, all donation transactions are processed directly between the donor and that Derasar's own
          registered Razorpay merchant account. JainamSevaSetu does not receive, hold, or control any donation
          funds at any point.
        </p>
        <p>
          Because JainamSevaSetu is not a party to donation transactions, it{' '}
          <strong>cannot issue, authorize, or compel any donation refund</strong>.
        </p>

        <h3>2. Donation Refunds — Derasar's Responsibility</h3>
        <p>
          Any refund request for a donation must be directed exclusively to the Derasar to which the donation
          was made. The Derasar Trust is solely responsible for evaluating and executing refunds through their
          own Razorpay merchant dashboard.
        </p>
        <p>
          JainamSevaSetu has no technical or legal ability to reverse or recover donation payments. We will not
          forward or mediate refund disputes on behalf of donors.
        </p>
        <p>
          For the contact details of your Derasar's administrator, log in to your JainamSevaSetu account and
          refer to your Derasar's profile.
        </p>

        <h3>3. Offerings / Unfulfilled Offerings</h3>
        <p>
          An offering represents a voluntary intent to donate. If an offering has not yet been paid, a member
          may request its cancellation by contacting their Derasar Administrator.
        </p>
        <p>
          Once a payment has been recorded against an offering, that amount is a completed donation and falls
          under the Derasar's own refund discretion as described in Section 2.
        </p>

        <h3>4. Platform Subscription Fees (Derasar Administrators)</h3>
        <p>
          Subscription fees paid to JainamSevaSetu for platform access are processed through JainamSevaSetu's
          own payment systems and are <strong>non-refundable</strong> once the subscription period has
          commenced.
        </p>
        <p>Two important conditions specific to this platform:</p>
        <ul>
          <li>
            <strong>Activation is not immediate.</strong> Payment does not grant instant access. All
            registrations and renewals require approval from the website owner before the subscription becomes
            active. If approval is denied after payment, contact us at{' '}
            <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a> for case-by-case
            resolution.
          </li>
          <li>
            <strong>Offline payment option.</strong> Where available for eligible accounts, offline payment
            registrations are confirmed only after the JainamSevaSetu team manually verifies receipt of funds.
          </li>
        </ul>
        <p>
          If you believe you were billed in error, raise a dispute within <strong>48 hours</strong> of the
          transaction at <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>.
        </p>

        <h3>5. Subscription Cancellation</h3>
        <p>
          To cancel your platform subscription, contact{' '}
          <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>. Access remains active until
          the end of your current paid period. No prorated refunds are issued for early cancellation.
        </p>

        <h3>6. Contact</h3>
        <p>
          <strong>JainamSevaSetu</strong><br />
          Email: <a href="mailto:jainamsevasetu@gmail.com">jainamsevasetu@gmail.com</a>
        </p>
      </div>
    </div>
  </section>
);

export default RefundPage;
